// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__18z0P","notes":"Notes_notes__3EERm"};